
import { Union, Record } from "../../../../fable_modules/fable-library-js.5.0.0-rc.2/Types.js";
import { union_type, record_type, option_type, class_type, bool_type, list_type, string_type } from "../../../../fable_modules/fable-library-js.5.0.0-rc.2/Reflection.js";
import { CreatedApiKeyDto_$reflection, ApiKeyDto_$reflection, ApiReceiver_$reflection } from "../../../../Shared/User.js";
import { ClientApiResponse$1_$reflection, FormState_$reflection, RequestedValue$1_$reflection } from "../../../../Shared/Shared.js";
import { ToolBox_$reflection, ReceiverHistoryRow_$reflection } from "../../../../Shared/Receiver.js";

export class State extends Record {
    constructor(ApiReceiverId, ApiReceiver, HistoryRows, ApiKeys, IsDialogOpen, Name, WritePermission, ExpirationDate, KeyPendingDeletion, CreatedKey, FormState) {
        super();
        this.ApiReceiverId = ApiReceiverId;
        this.ApiReceiver = ApiReceiver;
        this.HistoryRows = HistoryRows;
        this.ApiKeys = ApiKeys;
        this.IsDialogOpen = IsDialogOpen;
        this.Name = Name;
        this.WritePermission = WritePermission;
        this.ExpirationDate = ExpirationDate;
        this.KeyPendingDeletion = KeyPendingDeletion;
        this.CreatedKey = CreatedKey;
        this.FormState = FormState;
    }
}

export function State_$reflection() {
    return record_type("Settings.UserManagement.ApiReceiver.Details.Types.State", [], State, () => [["ApiReceiverId", string_type], ["ApiReceiver", RequestedValue$1_$reflection(ApiReceiver_$reflection())], ["HistoryRows", RequestedValue$1_$reflection(list_type(ReceiverHistoryRow_$reflection()))], ["ApiKeys", RequestedValue$1_$reflection(list_type(ApiKeyDto_$reflection()))], ["IsDialogOpen", bool_type], ["Name", string_type], ["WritePermission", bool_type], ["ExpirationDate", option_type(class_type("System.DateTime"))], ["KeyPendingDeletion", option_type(ApiKeyDto_$reflection())], ["CreatedKey", option_type(string_type)], ["FormState", FormState_$reflection()]]);
}

export class Msg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["ApiReceiverFetched", "ToolBoxFetched", "KeysFetched", "OpenDialog", "CloseDialog", "SetName", "SetWritePermission", "SetExpirationDate", "CreateKey", "KeyCreated", "CloseCreatedKeyDialog", "RequestDeleteKey", "CancelDeleteKey", "ConfirmDeleteKey", "KeyDeleted", "FetchError"];
    }
}

export function Msg_$reflection() {
    return union_type("Settings.UserManagement.ApiReceiver.Details.Types.Msg", [], Msg, () => [[["Item", ApiReceiver_$reflection()]], [["Item", ToolBox_$reflection()]], [["Item", list_type(ApiKeyDto_$reflection())]], [], [], [["Item", string_type]], [["Item", bool_type]], [["Item", option_type(class_type("System.DateTime"))]], [], [["Item", ClientApiResponse$1_$reflection(CreatedApiKeyDto_$reflection())]], [], [["Item", ApiKeyDto_$reflection()]], [], [], [["Item", ClientApiResponse$1_$reflection(string_type)]], [["Item", class_type("System.Exception")]]]);
}

